<template>
  <div class="container">
    <div
      class="logo c-pointer logo_container"
      @click="goto('home')"
      :style="person_flag ? 'margin-right:90px' : 'margin-right:138px'"
    >
      <img :src="require('@/assets/images/icon_logo.png')" alt="" />
      <div class="person_center" v-if="person_flag">
        <div>个人中心</div>
        <div @click="goto('home')">返回商城首页</div>
      </div>
    </div>
    <div class="search-box">
      <div class="search-container">
        <div class="search-info">
          <el-input
            class="inline-input"
            v-model="keyword"
            placeholder="请输入通用名 | 准字号 | 拼音码 | 厂家"
            @input="getgoodslist(keyword)"
            @blur="blur"
            @keyup.enter.native="search"
          >
            <!-- @keyup.enter.native="search" -->
            <div class="inputIcon" slot="prefix">
              <img :src="require('@/assets/images/icon_search.png')" alt="" />
            </div>
          </el-input>
          <!-- 推荐列表 -->
          <div v-if="commendList.length > 0">
            <ul class="commend" v-show="isShowCommend">
              <li
                v-for="(item, index) in commendList"
                :key="index"
                @click="handleSelect(item.id)"
              >
                <i v-if="item.purchased">购买过</i>
                <span class="c-pointer">{{
                  item.name + item.specification + item.manufacturer
                }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="search-btn c-pointer" @click="search">
          <img :src="require('@/assets/images/icon_search2.png')" alt="" />
          <span>搜索</span>
        </div>
      </div>
      
    </div>

    <!-- <div class="cart c-pointer" @click="goto('cartlist')">
      <img
        :src="require('@/assets/images/icon_shopping.png')"
        alt=""
        class="cart-icon"
      />
      <span class="cart-text">购物车</span>
      <span class="cart-num">{{ hasLogin ? cartNum || 0 : 0 }}</span>
      <img
        :src="require('@/assets/images/icon_more.png')"
        alt=""
        class="yjt-icon"
      />
    </div> -->
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      keyword: "", //搜索关键词
      commendList: [],
      isShowCommend: false,
      person_flag: false,
      activeShow: false,
      valid: true
    };
  },
  computed: {
    ...mapState(["hasLogin", "cartNum", "searchkeyword"]),
    ...mapState("sessionData", ["baseInfo"]),
    ...mapState("sessionData", ["notice_cid_7"]),
    hotList() {
      if (this.$route.name == "center" || this.$route.name == "myorder") {
        return [];
      } else {
        return (
          this.baseInfo.hotsearchWords &&
          this.baseInfo.hotsearchWords.split(",")
        );
      }
    },
    certList(){
      return this.notice_cid_7
    }
  },
  methods: {
    goto(name) {
      if (this.$route.name != name) this.$router.push({ name });
    },
    eventClick() {
      this.$emit("eventClick");
    },

    handleSelect(id) {
      //调用搜索按钮
      this.$router.push({
        name: "detail",
        query: { goodsId: id, type: 1 }
      });
    },
    search() {
      let keyword;
      keyword = this.keyword.replace(/[^\u4e00-\u9fa5a-zA-Z0-9\w]/g, "").trim();
      this.isShowCommend = false;
      //   this.$store.commit("GET_GOODSLIST", keyword);
      this.ANALYSISSAVE(keyword);
      this.$router.push({ name: "search", query: { keyword } });
    },
    getgoodslist() {
      let keyword = this.keyword
        .replace(/[^\u4e00-\u9fa5a-zA-Z0-9\w]/g, "")
        .trim();
      this.$store.commit("SEARCHKEYWORD", keyword);
      this.$api
        .GET_GOODSKEYWORD({
          keyword
        })
        .then(res => {
          if (res.status) this.commendList = res.data;
          this.isShowCommend = true;
          if (this.commendList.length == 0) {
            this.valid = false;
          } else {
            this.valid = true;
          }
        });
    },
    ANALYSISSAVE(data) {
      let domain = "http://www.dgsjyyy.com";
      let source = "web";
      let type = "search";
      let url = "http://www.dgsjyyy.com/search?keyword=" + data;
      let title = "搜索结果";
      let keyword = data;

      this.$api
        .POST_ANALYSISSAVE({
          domain,
          source,
          title,
          type,
          url,
          keyword,
          valid: this.valid
        })
        .then(res => {})
        .catch(err => console.log(err));
    },
    getgoodcount() {
      this.$api.POST_CARTCOUNT().then(res => {
        if (res.status) this.$store.commit("GETCARTCOUNT", res.data);
      });
    },
    searchHotWord(item) {
      // this.keyword = item;
      //  this.$store.commit("GET_GOODSLIST", this.keyword);
      this.$router.push({ name: "search", query: { keyword: item } });
      this.$nextTick(function() {
        this.isShowCommend = false;
      });
    },
    toDetail(id) {
      this.$router.push({ name: "helpcenter", query: { id } });
    },
    blur() {
      setTimeout(() => {
        this.isShowCommend = false;
      }, 150);
    }
  },
  created() {
    //  this.getgoodslist();
    if (this.$route.name == "search") {
      // this.keyword = this.$store.state.searchkeyword
      this.isShowCommend = false;
    } else {
      this.keyword = "";
    }
    if (this.$route.fullPath.indexOf("person") != -1) {
      this.person_flag = true;
    } else {
      this.person_flag = false;
    }
    // this.getgoodcount();
  },
  mounted() {
    //  this.$nextTick(function(){
    //    this.isShowCommend = false
    //   })
  },
  watch: {
    "$store.state.searchkeyword"(t, f) {
      this.keyword = t;
    },

    //跳出搜索页面清空关键词
    $route(t, f) {
      if (t.name != "search") {
        this.keyword = "";
      }
      if (t.query.keyword) {
        this.keyword = t.query.keyword;
      }
      if (t.fullPath.indexOf("person") != -1) {
        this.person_flag = true;
      } else {
        this.person_flag = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  padding-top: 25px;
  height: 110px;
  font-size: 12px;
  .logo {
    float: left;
    position: relative;
    margin-right: 138px;
    .medium {
      color: #999999;
      white-space: nowrap;
      line-height: 24px;
    }
  }
  .logo_container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    .person_center {
      font-size: 22px;
      color: #505050;
      margin-left: 18px;
      :nth-child(2) {
        margin-top: 10px;
        border: 1px solid #fa4b4b;
        color: #fa4b4b;
        width: 95px;
        line-height: 20px;
        font-size: 12px;
        border-radius: 10px;
        text-align: center;
      }
    }
  }

  .search-box {
    position: relative;
    display: flex;
    flex-direction: column;
    .subject {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      font-size: 12px;
      color: #666666;
      width: 520px;
      li {
        margin-right: 20px;
        line-height: 20px;
      }
    }
  }

  .search-container {
    border-radius: 2px;
    border: 1px solid #fa4b4b;
    margin-top: 10px;
    margin-right: 134px;
    float: left;
    width: 590px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    .search-btn {
      float: right;
      width: 114px;
      font-size: 14px;
      color: #ffffff;
      font-weight: 600;
      background: #fa4b4b;
      height: 100%;
      @include flex-c;
      img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }
      span {
        letter-spacing: 4px;
      }
    }
  }

  .cart {
    @include flex-c;
    margin-top: 10px;
    position: absolute;
    right: 0;
    top: 25px;
    width: 164px;
    border: 1px solid #e6e6e6;
    font-size: 14px;
    color: #404040;
    height: 40px;
    border-radius: 2px;
    .cart-icon {
      margin-right: 12px;
    }
    .cart-num {
      margin-left: 10px;
      margin-right: 14px;
      padding: 3px 6px;
      display: inline-block;
      text-align: center;
      color: #ffffff;
      background: #fa4b4b;
      border-radius: 10px;
      // width: 20px;
      //  height: 20px;
    }
  }
}
.inline-input {
  width: 474px;
}
>>> .el-input__inner {
  background-color: transparent;
  border: none;
  font-size: 13px;
  color: black;
}
.inputIcon {
  line-height: 41px;
  padding: 0 12px 0 16px;
}
>>> .el-input--prefix .el-input__inner {
  padding-left: 48px;
}
>>> .el-popper .popper__arrow {
  display: none;
}
>>> :-ms-input-placeholder.el-input__inner {
  color: #c0c4cc !important;
}
.commend {
  position: absolute;
  width: 474px;
  border: 1px solid #fa4b4b;
  border-top: none;
  background-color: #ffffff;
  z-index: 100;
  padding: 4px 0;
  // top: 0px;
  border-radius: 0 0 6px 6px;
  li {
    //  height: 25px;
    line-height: 25px;
    color: #505050;
    font-size: 14px;
    padding: 2px;
    padding-left: 10px;
    cursor: pointer;
    > i {
      font-size: 10px;
      background: #ff6666;
      color: #fff;
      padding: 1px 4px;
      border-radius: 4px;
      margin-right: 5px;
    }
    &:hover {
      color: #ff3e3e;
    }
  }
}
>>> .el-carousel {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 312px;
  line-height: 25px;
  color: #83868a;
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue